import { openFolder } from "@/components/misc";
import { ProjectProps } from "@/interfaces/project_types";
import { WeekCardFlag } from "./WeekCardFlag";
import { WeekCardStatus } from "./WeekCardStatus";

/**
 * This is the card that shows individual projects on the both the weekly and monthly calendars
 */

export function ProjectCard({
	project,
	navigate,
}: {
	project: ProjectProps;
	navigate: (route: string) => void;
}) {
	const status = project.status;
	const isDeadline = project.isDeadline;
	const project_id = project.project_id?.split("-")[0] || "";
	const project_folder_path = project.folder_location ?? "";

	const css_status = (status: string) => {
		if (isDeadline) {
			return "bg-red-100 dark:bg-red-900";
		}

		switch (status) {
			case "Review":
				return "bg-green-100 dark:bg-green-900";
			case "Completed":
				return "bg-red-100 dark:bg-red-900";
			default:
				return "bg-orange-50 dark:bg-orange-900";
		}
	};

	return (
		<div key={project.project_id} className="w-full mb-5">
			<div
				className={`group overflow-hidden rounded-lg ${css_status(status ?? "Active")}`}
			>
				<div className="text-blue-800 dark:text-blue-400 underline font-semibold text-xl py-1 px-2 flex items-center gap-2">
					<WeekCardFlag status={status} isDeadline={isDeadline} />

					<div
						className="w-full cursor-pointer font-bold"
						onClick={() =>
							navigate("/projects/update_project/" + project.project_id)
						}
					>
						{project.project_name}
					</div>
				</div>

				<div
					className="w-full cursor-pointer underline"
					onClick={() => openFolder(project_folder_path)}
				>
					<p className="text-base text-black dark:text-white">{project_id}</p>
				</div>

				<WeekCardStatus status={status} isDeadline={isDeadline} />

				<div className="bg-orange-100 dark:bg-stone-500 px-2">
					{project.description ? project.description : "(No description)"}
				</div>
			</div>
		</div>
	);
}
